import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "tw-rounded-2xl tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-900/5" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-justify-between tw-gap-3 tw-border-b tw-border-slate-200/70 tw-px-4 tw-py-3" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-gap-2 tw-text-base tw-font-semibold tw-text-slate-900" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_5 = { class: "tw-p-3 sm:tw-p-4" }
const _hoisted_6 = {
  key: 0,
  class: "tw-flex tw-items-center tw-justify-center tw-py-10"
}
const _hoisted_7 = {
  key: 1,
  class: "tw-overflow-x-auto tw-overflow-y-visible"
}
const _hoisted_8 = {
  key: 2,
  class: "tw-min-w-[1100px] tw-w-full tw-text-left tw-text-sm tw-leading-5"
}
const _hoisted_9 = {
  key: 0,
  class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600"
}
const _hoisted_10 = {
  key: 0,
  class: "tw-whitespace-nowrap tw-p-0.5 tw-pr-4"
}
const _hoisted_11 = {
  key: 1,
  class: "tw-whitespace-nowrap tw-p-0.5 tw-pr-4"
}
const _hoisted_12 = {
  key: 2,
  class: "tw-whitespace-nowrap tw-p-0.5 tw-pr-4"
}
const _hoisted_13 = {
  key: 3,
  class: "tw-whitespace-nowrap tw-p-0.5 tw-pr-4"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "tw-whitespace-nowrap" }
const _hoisted_16 = {
  key: 1,
  class: "tw-px-3 tw-py-2 tw-text-slate-900"
}
const _hoisted_17 = { class: "tw-whitespace-nowrap" }
const _hoisted_18 = ["onClick", "aria-label"]
const _hoisted_19 = ["title"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = {
  key: 0,
  class: "tw-mx-1"
}
const _hoisted_23 = {
  key: 1,
  class: ""
}
const _hoisted_24 = { key: 3 }
const _hoisted_25 = ["title"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 4 }
const _hoisted_29 = { key: 5 }
const _hoisted_30 = {
  key: 6,
  class: "tw-whitespace-nowrap"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { key: 3 }
const _hoisted_35 = { key: 4 }
const _hoisted_36 = {
  key: 5,
  class: "tw-whitespace-nowrap tw-font-medium tw-text-slate-800 tw-p-0.5 tw-border-2 tw-border-dotted tw-border-red-500 tw-w-auto tw-overflow-clip"
}
const _hoisted_37 = { class: "tw-flex tw-justify-center" }
const _hoisted_38 = {
  key: 1,
  class: "tw-border-t tw-border-slate-200/70"
}
const _hoisted_39 = {
  key: 0,
  class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-px-4 tw-py-6 tw-text-center"
}
const _hoisted_40 = {
  key: 1,
  class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-p-4"
}
const _hoisted_41 = {
  key: 3,
  class: "tw-min-w-[900px] tw-w-full tw-text-left tw-text-sm tw-leading-5"
}
const _hoisted_42 = { class: "tw-px-3 tw-py-2" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = {
  key: 4,
  class: "tw-px-3 tw-py-2"
}
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = ["onUpdate:modelValue"]
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = { class: "tw-flex tw-justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_OrderCancelContainerModal = _resolveComponent("OrderCancelContainerModal")!
  const _component_OrderEditContainerDetailsModal = _resolveComponent("OrderEditContainerDetailsModal")!
  const _component_OrderAddContainerModal = _resolveComponent("OrderAddContainerModal")!
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_YardStatusLabel = _resolveComponent("YardStatusLabel")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_OrderContainerDropdown = _resolveComponent("OrderContainerDropdown")!
  const _component_OrderContainerDetails = _resolveComponent("OrderContainerDetails")!
  const _component_InputField = _resolveComponent("InputField")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          icon: "sticky-note",
          class: "tw-h-4 tw-w-4 tw-text-slate-500"
        }),
        _createElementVNode("span", null, _toDisplayString(_ctx.baseLoadText) + "s", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.order.status != 'Complete' && _ctx.editable && _ctx.isLandOrder(_ctx.order))
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              onClick: _ctx.addNewFreightContent
            }, {
              default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                _createTextVNode("Add Freight Content", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]))
          : (_ctx.order.status != 'Complete' && _ctx.editable)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                onClick: _ctx.addNewContainer
              }, {
                default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                  _createTextVNode("Add Container", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isLoadingContainersQuery)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[43] || (_cache[43] = [
            _createElementVNode("div", { class: "tw-h-7 tw-w-7 tw-animate-spin tw-rounded-full tw-border-2 tw-border-slate-300 tw-border-t-slate-600" }, null, -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_OrderCancelContainerModal, {
              isOpen: _ctx.isCancelContainerModalOpen,
              "onUpdate:isOpen": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCancelContainerModalOpen) = $event)),
              containerLabel: _ctx.cancelContainerTarget?.containerId,
              onCancel: _ctx.closeCancelContainerModal,
              onSubmit: _ctx.submitCancelContainer
            }, null, 8, ["isOpen", "containerLabel", "onCancel", "onSubmit"]),
            (!_ctx.isLandOrder(_ctx.order))
              ? (_openBlock(), _createBlock(_component_OrderEditContainerDetailsModal, {
                  key: 0,
                  isOpen: _ctx.isEditContainerDetailsModalOpen,
                  "onUpdate:isOpen": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isEditContainerDetailsModalOpen) = $event)),
                  model: _ctx.editContainerDetailsModel,
                  isSaving: _ctx.isEditContainerDetailsSaving,
                  isExportOrder: _ctx.isOceanExport(_ctx.order),
                  onCancel: _ctx.closeEditContainerDetailsModal,
                  onSave: _ctx.saveEditContainerDetails
                }, null, 8, ["isOpen", "model", "isSaving", "isExportOrder", "onCancel", "onSave"]))
              : _createCommentVNode("", true),
            (!_ctx.isLandOrder(_ctx.order))
              ? (_openBlock(), _createBlock(_component_OrderAddContainerModal, {
                  key: 1,
                  isOpen: _ctx.isAddContainerModalOpen,
                  "onUpdate:isOpen": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isAddContainerModalOpen) = $event)),
                  model: _ctx.containerAddition,
                  isSaving: _ctx.containerAddition.isLoading,
                  "is-export-order": _ctx.isOceanExport(_ctx.order),
                  onCancel: _ctx.cancelContainerAddition,
                  onSave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmContainerAddition(_ctx.order)))
                }, null, 8, ["isOpen", "model", "isSaving", "is-export-order", "onCancel"]))
              : _createCommentVNode("", true),
            (!_ctx.isLandOrder(_ctx.order))
              ? (_openBlock(), _createElementBlock("table", _hoisted_8, [
                  _createElementVNode("thead", null, [
                    (_ctx.shouldShowContainerInfo)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                          _cache[44] || (_cache[44] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-p-0.5 tw-pr-4" }, "Container Number", -1)),
                          _cache[45] || (_cache[45] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-p-0.5 tw-pr-4" }, "Size Type", -1)),
                          _cache[46] || (_cache[46] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-p-0.5 tw-pr-4" }, "Seal Number", -1)),
                          _cache[47] || (_cache[47] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-p-0.5 tw-pr-4" }, "Cargo Pieces", -1)),
                          _cache[48] || (_cache[48] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-p-0.5 tw-pr-4" }, "Cargo Description", -1)),
                          _cache[49] || (_cache[49] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-p-0.5 tw-pr-4" }, "Weight", -1)),
                          (_ctx.shouldShowYardStatus)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_10, "Yard Status"))
                            : _createCommentVNode("", true),
                          (_ctx.shouldShowPickUpNumber)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_11, "Pick-Up #"))
                            : _createCommentVNode("", true),
                          (_ctx.shouldShowReleaseNumber)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_12, "Release #"))
                            : _createCommentVNode("", true),
                          (_ctx.shouldShowEtaOrLfd)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_13, "ETA/LFD"))
                            : _createCommentVNode("", true),
                          _cache[50] || (_cache[50] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-p-0.5 tw-pr-4" }, "EIR/Appt", -1)),
                          _cache[51] || (_cache[51] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-p-0.5 tw-pr-4" }, "Status", -1)),
                          _cache[52] || (_cache[52] = _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, null, -1))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.containersWithTrips, (container, containerIdx) => {
                    return (_openBlock(), _createElementBlock("tbody", {
                      key: container.id
                    }, [
                      (
              _ctx.showTripForContainerIdx == container.id ||
              _ctx.showTripForContainerIdx == -1
            )
                        ? (_openBlock(), _createElementBlock("tr", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.toggleTripStatusSingleContainer(container.id)),
                            class: _normalizeClass(["container-item-row tw-cursor-pointer tw-border-t tw-border-slate-200/70 hover:tw-bg-slate-900/5", {
              'clr-storm-6':
                _ctx.showTripForContainerIdx == container.id ||
                _ctx.showContainerHistoryIdx == container.id,
              'tall-row':
                _ctx.showTripForContainerIdx == container.id ||
                _ctx.showContainerHistoryIdx == container.id,
              'tw-bg-amber-100/70': _ctx.lastOpenedContainerIdx == container.id,
            }])
                          }, [
                            (_ctx.isEditingContainerNumber == container.id)
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 0,
                                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent","stop"])),
                                  class: "tw-px-3 tw-py-2"
                                }, [
                                  _createElementVNode("div", _hoisted_15, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "tw-w-56 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                                      type: "text",
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editingContainerNumber) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.editingContainerNumber]
                                    ]),
                                    _createVNode(_component_Button, {
                                      onClick: ($event: any) => (_ctx.saveContainerNumber(container)),
                                      disabled: _ctx.isContainerEditingNumberInvalid,
                                      isGray: _ctx.isContainerEditingNumberInvalid,
                                      isGreen: !_ctx.isContainerEditingNumberInvalid,
                                      class: "tw-ml-2 tw-h-9 tw-w-9 tw-p-0",
                                      icon: "check",
                                      title: "Save container number",
                                      "aria-label": "Save container number"
                                    }, null, 8, ["onClick", "disabled", "isGray", "isGreen"]),
                                    _createVNode(_component_Button, {
                                      onClick: _ctx.cancelContainerNumberEdit,
                                      isRed: true,
                                      class: "tw-ml-1 tw-h-9 tw-w-9 tw-p-0",
                                      icon: "xmark",
                                      title: "Cancel container number edit",
                                      "aria-label": "Cancel container number edit"
                                    }, null, 8, ["onClick"])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("td", _hoisted_16, [
                                  _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "tw-mr-1 tw-inline-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-md tw-text-slate-500 hover:tw-bg-white/60 hover:tw-text-slate-700 focus:tw-outline-none",
                                      onClick: _withModifiers(($event: any) => (_ctx.toggleContainerHistory(container.id)), ["prevent","stop"]),
                                      "aria-label": (_ctx.showContainerHistoryIdx == container.id || _ctx.showTripForContainerIdx == container.id) ? 'Collapse' : 'Expand'
                                    }, [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "chevron-down",
                                        class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-transition-transform", {
                    'tw-rotate-0': _ctx.showTripForContainerIdx == container.id || _ctx.showContainerHistoryIdx == container.id,
                    '-tw-rotate-90': !(_ctx.showTripForContainerIdx == container.id || _ctx.showContainerHistoryIdx == container.id),
                  }])
                                      }, null, 8, ["class"])
                                    ], 8, _hoisted_18),
                                    _createElementVNode("span", {
                                      class: "tw-inline-flex tw-items-center tw-gap-2",
                                      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent","stop"]))
                                    }, [
                                      _createElementVNode("strong", null, [
                                        _createTextVNode(_toDisplayString(_ctx.order.id) + "-" + _toDisplayString(_ctx.pad(container.internalIndex || containerIdx + 1, 2)) + "-", 1),
                                        (!container.containerId || container.containerId === 'EXPUNDEF')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(" (not set) ")
                                            ], 64))
                                          : (_openBlock(), _createBlock(_component_CopyButton, {
                                              key: 1,
                                              value: container.containerId,
                                              mode: "wrap-content",
                                              title: "Copy container number",
                                              "aria-label": "Copy container number"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(container.containerId), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                      ]),
                                      (container.isCancelled)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "tw-ml-2 tw-inline-flex tw-items-center tw-rounded-md tw-bg-rose-50 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-rose-800 tw-ring-1 tw-ring-inset tw-ring-rose-600/20",
                                            title: container.cancelledReason || 'Cancelled'
                                          }, " Cancelled ", 8, _hoisted_19))
                                        : _createCommentVNode("", true),
                                      _cache[53] || (_cache[53] = _createTextVNode("   ", -1)),
                                      (_ctx.editable && !container.isCancelled)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            type: "button",
                                            class: "tw-inline-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-md tw-text-slate-500 hover:tw-bg-white/60 hover:tw-text-slate-700 focus:tw-outline-none",
                                            onClick: _withModifiers(($event: any) => (_ctx.addContainerNumber(container)), ["prevent","stop"]),
                                            "aria-label": "Edit container number",
                                            title: "Edit container number"
                                          }, [
                                            _createVNode(_component_font_awesome_icon, {
                                              icon: "pen",
                                              class: "tw-h-3.5 tw-w-3.5"
                                            })
                                          ], 8, _hoisted_20))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])),
                            (_ctx.shouldShowContainerInfo)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                                  _createTextVNode(_toDisplayString(container.sizeType) + " ", 1),
                                  (container.isGensetRequired)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_22, [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "bolt-lightning",
                                          class: _normalizeClass(["tw-h-3 tw-w-3", container.isGensetApprovedByShipline === true ? 'tw-text-emerald-400' : 'tw-text-slate-500'])
                                        }, null, 8, ["class"])
                                      ])), [
                                        [_directive_tippy, { content: container.isGensetApprovedByShipline === true ? 'Genset needed, approved' : 'Genset needed, NOT approved yet', placement: 'top' }]
                                      ])
                                    : _createCommentVNode("", true),
                                  (_ctx.getHasGensetTemperatureOrVents(container))
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_23, [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "temperature-high",
                                          class: "tw-h-3 tw-w-3 tw-text-slate-500"
                                        })
                                      ])), [
                                        [_directive_tippy, { content: _ctx.getGensetTemperatureAndVentsTooltip(container), placement: 'bottom' }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", null, _toDisplayString(container.sealNumber), 1),
                            _createElementVNode("td", null, _toDisplayString(container.freightContents[0].cargoPieces), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.cargoDescriptionString(container)), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.containerWeight(container.freightContents[0].weight)), 1),
                            (_ctx.shouldShowYardStatus)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                                  (container.isCancelled)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "tw-text-sm tw-text-rose-800",
                                        title: container.cancelledReason || undefined
                                      }, [
                                        _cache[54] || (_cache[54] = _createTextVNode(" Cancelled", -1)),
                                        (container.cancelledReason)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, " — " + _toDisplayString(container.cancelledReason), 1))
                                          : _createCommentVNode("", true)
                                      ], 8, _hoisted_25))
                                    : (container.isActive || !_ctx.editable)
                                      ? (_openBlock(), _createBlock(_component_YardStatusLabel, {
                                          key: 1,
                                          container: container
                                        }, null, 8, ["container"]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_27, "Container Archived"))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.shouldShowPickUpNumber)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_28, _toDisplayString(container.pickupNumber), 1))
                              : _createCommentVNode("", true),
                            (_ctx.shouldShowReleaseNumber)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_29, _toDisplayString(container.releaseNumber), 1))
                              : _createCommentVNode("", true),
                            (_ctx.shouldShowEtaOrLfd)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                                  (_ctx.getIsEtaShownForYardStatus(container.yardStatus))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode("ETA " + _toDisplayString(container.eta), 1)
                                      ], 64))
                                    : (container.lfd && container.lfd.length > 2)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode("LFD " + _toDisplayString(container.lfd), 1)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          _createTextVNode("No LFD")
                                        ], 64))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", null, [
                              (container.eirInDate)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_31, " EIR In: " + _toDisplayString(_ctx.formatDate(container.eirInDate)), 1))
                                : _createCommentVNode("", true),
                              (container.eirOutDate)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_32, " EIR Out: " + _toDisplayString(_ctx.formatDate(container.eirOutDate)), 1))
                                : _createCommentVNode("", true),
                              (container.terminalAppointmentDate)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_33, " Term Appt: " + _toDisplayString(_ctx.formatAppointmentDatetime(container.terminalAppointmentDate, container.terminalAppointmentHasTime)), 1))
                                : _createCommentVNode("", true),
                              (container.deliveryAppointmentDate)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(_ctx.isOceanExport(_ctx.order) ? 'Pick-Up Appt' : 'Deliv Appt') + ": " + _toDisplayString(_ctx.formatAppointmentDatetime(container.deliveryAppointmentDate, container.deliveryAppointmentHasTime)), 1))
                                : _createCommentVNode("", true),
                              (container.returnTerminalAppointmentDate || _ctx.getIsReturningToDifferentLocation(container.terminal, container.returnLocation))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_35, [
                                    _cache[55] || (_cache[55] = _createTextVNode(" Return Term Appt: ", -1)),
                                    (container.returnTerminalAppointmentDate)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(_ctx.formatAppointmentDatetime(container.returnTerminalAppointmentDate, container.returnTerminalAppointmentHasTime)), 1)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.getIsReturningToDifferentLocation(container.terminal, container.returnLocation))
                                ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_36, [
                                    _cache[56] || (_cache[56] = _createTextVNode(" Return to: ", -1)),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(_ctx.getTerminalColorClassForLocation(container.returnLocation))
                                    }, "* " + _toDisplayString(_ctx.getLocationDisplayName(container.returnLocation)), 3)
                                  ])), [
                                    [_directive_tippy, container.returnLocation.name+', '+container.returnLocation.address.address]
                                  ])
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, [
                              (container.isCancelled)
                                ? (_openBlock(), _createBlock(_component_Badge, {
                                    key: 0,
                                    isRed: true
                                  }, {
                                    default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                      _createTextVNode("Cancelled", -1)
                                    ]))]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_Badge, {
                                    key: 1,
                                    isGreen: _ctx.tripCompletionText(container.trips) == 'In Progress',
                                    isOrange: _ctx.tripCompletionText(container.trips) == 'Complete'
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.tripCompletionText(container.trips)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["isGreen", "isOrange"]))
                            ]),
                            _createElementVNode("td", {
                              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createElementVNode("div", _hoisted_37, [
                                (_ctx.editable)
                                  ? (_openBlock(), _createBlock(_component_OrderContainerDropdown, {
                                      key: 0,
                                      onShowContainer: _ctx.showContainer,
                                      onEditContainerDetails: _ctx.editContainerDetails,
                                      onToggleTripStatus: _ctx.toggleTripStatus,
                                      onAddContainerNumber: _ctx.addContainerNumber,
                                      onAddEmptyTrip: _ctx.addEmptyTrip,
                                      onCancelContainer: _ctx.openCancelContainerModal,
                                      onUncancelContainer: _ctx.uncancelContainer,
                                      order: _ctx.order,
                                      container: container,
                                      containerIdx: containerIdx
                                    }, null, 8, ["onShowContainer", "onEditContainerDetails", "onToggleTripStatus", "onAddContainerNumber", "onAddEmptyTrip", "onCancelContainer", "onUncancelContainer", "order", "container", "containerIdx"]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ], 10, _hoisted_14))
                        : _createCommentVNode("", true),
                      (_ctx.showContainerHistoryIdx == container.id)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [
                            _createElementVNode("td", {
                              colspan: 99,
                              class: "tw-px-3 tw-py-4",
                              onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              (!container?.trips || container.trips.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [...(_cache[58] || (_cache[58] = [
                                    _createElementVNode("div", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "No data", -1),
                                    _createElementVNode("div", { class: "tw-mt-1 tw-text-sm tw-text-slate-600" }, "No trips are available for this container yet.", -1)
                                  ]))]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    _createVNode(_component_OrderContainerDetails, {
                                      chassis: _ctx.chassis,
                                      drivers: _ctx.drivers,
                                      order: _ctx.order,
                                      editable: _ctx.editable && !container.isCancelled,
                                      containerId: container.id
                                    }, null, 8, ["chassis", "drivers", "order", "editable", "containerId"])
                                  ]))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("table", _hoisted_41, [
                  _cache[63] || (_cache[63] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600" }, [
                      _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-3 tw-py-2" }, "Quantity"),
                      _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-3 tw-py-2" }, "Package Type"),
                      _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-3 tw-py-2" }, "Is Hazmat"),
                      _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-3 tw-py-2" }, "Weight (lbs)"),
                      _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-3 tw-py-2" }, "Description"),
                      _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-3 tw-py-2" }, "NMFC #"),
                      _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-3 tw-py-2" }, "NMFC Class"),
                      _createElementVNode("th", { class: "tw-px-3 tw-py-2" })
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (
              (_ctx.showTripForContainerIdx == _ctx.containersWithTrips[0].id ||
                _ctx.showTripForContainerIdx == -1) &&
              _ctx.addingFreightContent
            )
                      ? (_openBlock(), _createElementBlock("tr", {
                          key: 0,
                          class: _normalizeClass({
              'clr-storm-6':
                _ctx.showTripForContainerIdx == _ctx.containersWithTrips[0].id ||
                _ctx.showContainerHistoryIdx == _ctx.containersWithTrips[0].id,
              'tall-row':
                _ctx.showTripForContainerIdx == _ctx.containersWithTrips[0].id ||
                _ctx.showContainerHistoryIdx == _ctx.containersWithTrips[0].id,
            })
                        }, [
                          _createElementVNode("td", {
                            class: "tw-px-3 tw-py-2",
                            onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent","stop"]))
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "tw-w-40 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                              type: "text",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.freightContentAddition.quantity) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.freightContentAddition.quantity]
                            ])
                          ]),
                          _createElementVNode("td", {
                            class: "tw-px-3 tw-py-2",
                            onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent","stop"]))
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "tw-w-44 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                              type: "text",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.freightContentAddition.packingType) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.freightContentAddition.packingType]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_42, [
                            _createVNode(_component_InputField, {
                              type: "checkbox",
                              modelValue: _ctx.freightContentAddition.isHazmat,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.freightContentAddition.isHazmat) = $event)),
                              id: "IsHazmat"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("td", {
                            class: "tw-px-3 tw-py-2",
                            onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["prevent","stop"]))
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "tw-w-40 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                              type: "text",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.freightContentAddition.weight) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.freightContentAddition.weight]
                            ])
                          ]),
                          _createElementVNode("td", {
                            class: "tw-px-3 tw-py-2",
                            onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["prevent","stop"]))
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "tw-w-64 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                              type: "text",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.freightContentAddition.description) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.freightContentAddition.description]
                            ])
                          ]),
                          _createElementVNode("td", {
                            class: "tw-px-3 tw-py-2",
                            onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["prevent","stop"]))
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "tw-w-40 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                              type: "text",
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.freightContentAddition.nmfcNumber) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.freightContentAddition.nmfcNumber]
                            ])
                          ]),
                          _createElementVNode("td", {
                            class: "tw-px-3 tw-py-2",
                            onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["prevent","stop"]))
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "tw-w-32 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                              type: "text",
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.freightContentAddition.nmfcClass) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.freightContentAddition.nmfcClass]
                            ])
                          ]),
                          _createElementVNode("td", {
                            class: "tw-px-3 tw-py-2",
                            onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createVNode(_component_Button, {
                              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.saveNewFreightContent()))
                            }, {
                              default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                                _createTextVNode("Save", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_Button, {
                              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.cancelFreightContentAdd())),
                              class: "tw-ml-2",
                              isGray: true
                            }, {
                              default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                                _createTextVNode("Cancel", -1)
                              ]))]),
                              _: 1
                            })
                          ])
                        ], 2))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.containersWithTrips[0]
              .freightContents, (freightContent, freightContentIdx) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: freightContent.id,
                        class: _normalizeClass({
              'clr-storm-6':
                _ctx.showTripForContainerIdx == _ctx.containersWithTrips[0].id ||
                _ctx.showContainerHistoryIdx == _ctx.containersWithTrips[0].id,
              'tall-row':
                _ctx.showTripForContainerIdx == _ctx.containersWithTrips[0].id ||
                _ctx.showContainerHistoryIdx == _ctx.containersWithTrips[0].id,
            })
                      }, [
                        (_ctx.editingFreightContentIdx == freightContentIdx)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["prevent","stop"])),
                              class: "tw-px-3 tw-py-2"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "tw-w-40 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((freightContent.cargoPieces) = $event)
                              }, null, 8, _hoisted_43), [
                                [_vModelText, freightContent.cargoPieces]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("td", {
                              key: 1,
                              class: "tw-px-3 tw-py-2 tw-text-slate-900",
                              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.toggleTripStatus(_ctx.containersWithTrips[0].id)))
                            }, [
                              _createElementVNode("p", null, _toDisplayString(freightContent.cargoPieces), 1)
                            ])),
                        (_ctx.editingFreightContentIdx == freightContentIdx)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 2,
                              onClick: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["prevent","stop"])),
                              class: "tw-px-3 tw-py-2"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "tw-w-44 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((freightContent.packingType) = $event)
                              }, null, 8, _hoisted_44), [
                                [_vModelText, freightContent.packingType]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("td", {
                              key: 3,
                              class: "tw-px-3 tw-py-2 tw-text-slate-900",
                              onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.toggleTripStatus(_ctx.containersWithTrips[0].id)))
                            }, [
                              _createElementVNode("p", null, _toDisplayString(freightContent.packingType), 1)
                            ])),
                        (_ctx.editingFreightContentIdx == freightContentIdx)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_45, [
                              _createVNode(_component_InputField, {
                                type: "checkbox",
                                modelValue: freightContent.isHazmat,
                                "onUpdate:modelValue": ($event: any) => ((freightContent.isHazmat) = $event),
                                id: "IsHazmat2"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]))
                          : (_openBlock(), _createElementBlock("td", {
                              key: 5,
                              class: "tw-px-3 tw-py-2 tw-text-slate-900",
                              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.toggleTripStatus(_ctx.containersWithTrips[0].id)))
                            }, [
                              _createElementVNode("p", null, _toDisplayString(freightContent.isHazmat), 1)
                            ])),
                        (_ctx.editingFreightContentIdx == freightContentIdx)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 6,
                              onClick: _cache[30] || (_cache[30] = _withModifiers(() => {}, ["prevent","stop"])),
                              class: "tw-px-3 tw-py-2"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "tw-w-40 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((freightContent.weight) = $event)
                              }, null, 8, _hoisted_46), [
                                [_vModelText, freightContent.weight]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("td", {
                              key: 7,
                              class: "tw-px-3 tw-py-2 tw-text-slate-900",
                              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.toggleTripStatus(_ctx.containersWithTrips[0].id)))
                            }, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.containerWeight(freightContent.weight)), 1)
                            ])),
                        (_ctx.editingFreightContentIdx == freightContentIdx)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 8,
                              onClick: _cache[32] || (_cache[32] = _withModifiers(() => {}, ["prevent","stop"])),
                              class: "tw-px-3 tw-py-2"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "tw-w-64 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((freightContent.cargoDescription) = $event)
                              }, null, 8, _hoisted_47), [
                                [_vModelText, freightContent.cargoDescription]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("td", {
                              key: 9,
                              class: "tw-px-3 tw-py-2 tw-text-slate-900",
                              onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.toggleTripStatus(_ctx.containersWithTrips[0].id)))
                            }, [
                              _createElementVNode("p", null, _toDisplayString(freightContent.cargoDescription), 1)
                            ])),
                        (_ctx.editingFreightContentIdx == freightContentIdx)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 10,
                              onClick: _cache[34] || (_cache[34] = _withModifiers(() => {}, ["prevent","stop"])),
                              class: "tw-px-3 tw-py-2"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "tw-w-40 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((freightContent.nmfcNumber) = $event)
                              }, null, 8, _hoisted_48), [
                                [_vModelText, freightContent.nmfcNumber]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("td", {
                              key: 11,
                              class: "tw-px-3 tw-py-2 tw-text-slate-900",
                              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.toggleTripStatus(_ctx.containersWithTrips[0].id)))
                            }, [
                              _createElementVNode("p", null, _toDisplayString(freightContent.nmfcNumber), 1)
                            ])),
                        (_ctx.editingFreightContentIdx == freightContentIdx)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 12,
                              onClick: _cache[36] || (_cache[36] = _withModifiers(() => {}, ["prevent","stop"])),
                              class: "tw-px-3 tw-py-2"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "tw-w-32 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((freightContent.nmfcClass) = $event)
                              }, null, 8, _hoisted_49), [
                                [_vModelText, freightContent.nmfcClass]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("td", {
                              key: 13,
                              class: "tw-px-3 tw-py-2 tw-text-slate-900",
                              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.toggleTripStatus(_ctx.containersWithTrips[0].id)))
                            }, [
                              _createElementVNode("p", null, _toDisplayString(freightContent.nmfcClass), 1)
                            ])),
                        (_ctx.editingFreightContentIdx === freightContentIdx)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 14,
                              onClick: _cache[39] || (_cache[39] = _withModifiers(() => {}, ["stop"])),
                              class: "tw-px-3 tw-py-2"
                            }, [
                              _createVNode(_component_Button, {
                                onClick: ($event: any) => (_ctx.saveFreightContent(freightContent))
                              }, {
                                default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                                  _createTextVNode("Save", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_Button, {
                                onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.cancelFreightContentEdit())),
                                class: "tw-ml-2",
                                isGray: true
                              }, {
                                default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                                  _createTextVNode("Cancel", -1)
                                ]))]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("td", {
                              key: 15,
                              onClick: _cache[40] || (_cache[40] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createElementVNode("div", _hoisted_50, [
                                (_ctx.editable)
                                  ? (_openBlock(), _createBlock(_component_OrderContainerDropdown, {
                                      key: 0,
                                      onShowContainer: _ctx.showContainer,
                                      onEditContainerDetails: _ctx.editContainerDetails,
                                      onEditFreightContent: _ctx.editFreightContent,
                                      onToggleTripStatus: _ctx.toggleTripStatus,
                                      onAddContainerNumber: _ctx.addContainerNumber,
                                      onAddEmptyTrip: _ctx.addEmptyTrip,
                                      onCancelContainer: _ctx.openCancelContainerModal,
                                      onUncancelContainer: _ctx.uncancelContainer,
                                      isLand: _ctx.isLandOrder(_ctx.order),
                                      order: _ctx.order,
                                      freightContent: freightContent,
                                      freightContentIdx: freightContentIdx,
                                      container: _ctx.containersWithTrips[0],
                                      containerIdx: _ctx.containersWithTrips[0].id
                                    }, null, 8, ["onShowContainer", "onEditContainerDetails", "onEditFreightContent", "onToggleTripStatus", "onAddContainerNumber", "onAddEmptyTrip", "onCancelContainer", "onUncancelContainer", "isLand", "order", "freightContent", "freightContentIdx", "container", "containerIdx"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                      ], 2))
                    }), 128))
                  ])
                ]))
          ]))
    ])
  ]))
}